import _ from 'lodash';
import React from 'react';
import { useQuery } from 'react-query';
import { Button, Space, Popconfirm, Tree, Skeleton, Divider, Tooltip } from 'antd';
import { EditOutlined, DeleteOutlined, FolderOutlined, PlusOutlined, FolderOpenFilled } from '@ant-design/icons';

import withAuthenticator from 'HOCs/withAuthenticator';
import { getWithoutModuleId, remove } from 'helpers/QueryHelper';
import { buildTreeData, buildSelectTreeData } from 'utils';

import TeacherContainer from 'components/Containers/TeacherContainer';
import { LoggedInUserType } from 'types';
import { useSelector } from 'react-redux';
import UpdateFolder from './components/UpdateFolder';

const fetcher = (loggedInUser: LoggedInUserType) => () => {
  return getWithoutModuleId('RenLuyenBoiDuong', '*', { createdBy: loggedInUser?.id, classId: 0 }, 'Name, SortOrder');
};

type Props = {
  loggedInUser?: LoggedInUserType;
  onSelect: Function;
};

const FolderTreeView = ({ loggedInUser, onSelect }: Props) => {
  const [refresh, setRefresh] = React.useState(new Date());
  const [updateModalVisible, setUpdateModalVisible] = React.useState(false);
  const [selectedFolder, setSelectedFolder] = React.useState<any>(null);

  const [updateMode, setUpdateMode] = React.useState<string>('');
  const loggedInU = useSelector((state: any) => state.authReducer.loggedInUser);
  const key = ['RenLuyenBoiDuong', loggedInUser?.id, refresh];
  // QUERY
  const { data: records, isLoading } = useQuery(key, fetcher(loggedInUser));

  return (
    <React.Fragment>
      <Skeleton active loading={isLoading}>
        <TeacherContainer>
          <UpdateFolder
            updateMode={updateMode}
            treeData={buildSelectTreeData(records)}
            data={{ createdBy: loggedInUser?.id || loggedInU?.id, ...selectedFolder }}
            visible={updateModalVisible}
            onOk={() => {
              setRefresh(new Date());
              setUpdateModalVisible(false);
            }}
            onCancel={() => {
              setUpdateModalVisible(false);
            }}
            // loggedInUser={undefined}
          />

          <Space size='small' wrap>
            <Tooltip title='Tạo thư mục' placement='bottom'>
              <Button
                shape='circle'
                type='dashed'
                icon={<PlusOutlined />}
                onClick={() => {
                  setUpdateMode('add');
                  setUpdateModalVisible(true);
                }}
              />
            </Tooltip>
            {selectedFolder && (
              <React.Fragment>
                <Tooltip title='Sửa thư mục' placement='bottom'>
                  <Button
                    shape='circle'
                    type='dashed'
                    icon={<EditOutlined />}
                    style={{ alignSelf: 'flex-end' }}
                    onClick={() => {
                      setUpdateMode('edit');
                      setUpdateModalVisible(true);
                    }}
                  />
                </Tooltip>

                <Popconfirm
                  title='Bạn có muốn xóa thư mục này không?'
                  onConfirm={async () => {
                    await remove('RenLuyenBoiDuong', selectedFolder.id);
                    setRefresh(new Date());
                  }}
                  okText='Xác nhận'
                  cancelText='Không'
                >
                  <Tooltip title='Xóa thư mục' placement='bottom'>
                    <Button shape='circle' type='dashed' danger icon={<DeleteOutlined />} style={{ alignSelf: 'flex-end' }} />
                  </Tooltip>
                </Popconfirm>
              </React.Fragment>
            )}
          </Space>
          <Divider style={{ marginBottom: 12 }} />
        </TeacherContainer>
        <Tree.DirectoryTree
          icon={(props: any) => {
            return (
              <React.Fragment>
                {props.selected ? <FolderOpenFilled className='tw-mr-1' style={{ color: props.data.color, fontSize: 16 }} /> : <FolderOutlined className='tw-mr-1' style={{ color: props.data.color, fontSize: 16 }} />}
              </React.Fragment>
            );
          }}
          multiple={false}
          defaultExpandAll
          onSelect={(selectedKeys, info) => {
            if (info.selected) {
              const id = info.node.key;
              const folder = _.find(records, (x) => x.id === id);
              setSelectedFolder(folder);
              onSelect(folder);
            }
          }}
          treeData={buildTreeData(records)}
        />
      </Skeleton>
    </React.Fragment>
  );
};

FolderTreeView.defaultProps = {
  loggedInUser: null,
};

export default withAuthenticator(FolderTreeView);
